import apiClient from "./apiClient";

/**
 * Fetch Pipeline Board Columns and Deals
 * @param {string} companyCode
 * @param {object} filters
 * @param {number} pageSize
 */
export const getPipelineBoard = async (companyCode, filters = {}, pageSize = 50) => {
  try {
    const params = {};
    if (companyCode) params.companyCode = companyCode;
    if (pageSize) params.pageSize = pageSize;
    if (filters.employeeId) params.employeeId = filters.employeeId;
    if (filters.owner && filters.owner !== "all") params.owner = filters.owner;
    if (filters.priority && filters.priority !== "all") params.priority = filters.priority;
    if (filters.search) params.search = filters.search;
    if (filters.dateFilter) params.dateFilter = filters.dateFilter;
    if (filters.stage) params.stage = filters.stage;

    const res = await apiClient.get("/api/pipeline/board", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("getPipelineBoard error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Load more leads/deals for a single column
 */
export const loadMorePipelineColumn = async (companyCode, stage, page = 1, filters = {}, pageSize = 25) => {
  try {
    const params = {};
    if (companyCode) params.companyCode = companyCode;
    if (stage) params.stage = stage;
    if (page) params.page = page;
    if (pageSize) params.pageSize = pageSize;
    if (filters.employeeId) params.employeeId = filters.employeeId;
    if (filters.owner && filters.owner !== "all") params.owner = filters.owner;
    if (filters.priority && filters.priority !== "all") params.priority = filters.priority;
    if (filters.search) params.search = filters.search;

    const res = await apiClient.get("/api/pipeline/board/column", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("loadMorePipelineColumn error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Update lead pipeline stage
 */
export const updateLeadPipelineStage = async (leadId, payload, companyCode) => {
  try {
    const res = await apiClient.patch(
      `/api/pipeline/leads/${leadId}/stage`,
      payload,
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return res;
  } catch (error) {
    console.error("updateLeadPipelineStage error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Get all deals
 */
export const getDeals = async (companyCode, options = {}) => {
  try {
    const params = {};
    if (companyCode) params.companyCode = companyCode;
    if (options.clientId) params.clientId = options.clientId;
    if (options.leadId) params.leadId = options.leadId;
    if (options.leadCompanyName) params.leadCompanyName = options.leadCompanyName;
    if (options.companyName) params.companyName = options.companyName;
    if (options.contactNumber) params.contactNumber = options.contactNumber;
    if (options.stage) params.stage = options.stage;
    if (options.search) params.search = options.search;
    if (options.excludeClosed !== undefined) params.excludeClosed = options.excludeClosed;

    const res = await apiClient.get("/api/deals", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("getDeals error:", error);
    return { success: false, message: error.message, data: [], deals: [] };
  }
};

/**
 * Create a new deal
 */
export const createDeal = async (companyCode, dealData) => {
  try {
    const res = await apiClient.post(
      "/api/deals",
      { ...dealData, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return res;
  } catch (error) {
    console.error("createDeal error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Fetch stagnant deals that have been in the same stage for more than N days
 */
export const getStagnantDeals = async (companyCode, options = {}) => {
  try {
    const params = {};
    if (companyCode) params.companyCode = companyCode;
    if (options.days) params.days = options.days;
    if (options.employeeId) params.employeeId = options.employeeId;
    if (options.owner) params.owner = options.owner;

    const res = await apiClient.get("/api/pipeline/stagnant-deals", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("getStagnantDeals error:", error);
    return { success: false, message: error.message, deals: [], count: 0 };
  }
};
